import Div from './Div';

export default Div;
